( function () {
    'use strict';
    // fjern fokus fra bootstrap tabs efter der er klikket
    e.bootstrap = e.bootstrap || {};
    e.bootstrap.tabs = {};
    e.bootstrap.tabs.onFocusThisBlur = function () {
        jQuery( '.nav-tabs a[data-toggle="tab"]' ).on( 'focus', function () {
            jQuery( this ).trigger( 'blur' );
        } );
    };
}() );
